import React from 'react';
import { Button } from 'reactstrap';

export function FooterButtons({
  onClose,
  onSave,
  saveDisabled = false,
  closeDisabled = false,
  showSaveButton = true,
  closeText = 'Close',
  saveText = 'Update Status',
  additionalButtons = null,
}) {
  return (
    <footer className="buttons-group-wrapper">
      <div className="buttons-group">
        {additionalButtons}
        <Button
          className="clear"
          color="secondary"
          onClick={onClose}
          disabled={closeDisabled}
        >
          {closeText}
        </Button>
        {showSaveButton && (
          <Button
            className="save-update"
            color="primary"
            disabled={saveDisabled}
            onClick={onSave}
          >
            {saveText}
          </Button>
        )}
      </div>
    </footer>
  );
}
